import {
  Component,
  Input,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Output,
} from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import type { LeafLink } from '@cigna/leaf-web/lib/wc';

import '@cigna/leaf-web/lib/wc/components/link/link';

@Component({
  selector: 'cigna-leaf-link',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-link
      [href]="href"
      [rel]="rel"
      [target]="target"
      [iconRotateDegree]="iconRotateDegree"
      [iconFlipDirection]="iconFlipDirection"
      [iconPosition]="iconPosition"
      [ctaLink]="ctaLink"
      [noUnderline]="noUnderline"
      [size]="size"
      [inverted]="inverted"
      [svg]="svg"
      (click)="handleClick($event)"
      ><ng-content></ng-content
    ></leaf-link>
  `,
})
export class CignaLeafLinkComponent {
  @Input({ required: true }) href: LeafLink['href'];
  @Input() ctaLink: LeafLink['ctaLink'];
  @Input() iconFlipDirection: LeafLink['iconFlipDirection'];
  @Input() iconPosition: LeafLink['iconPosition'];
  @Input() iconRotateDegree: LeafLink['iconRotateDegree'];
  @Input() inverted: LeafLink['inverted'];
  @Input() noUnderline: LeafLink['noUnderline'];
  @Input() rel: LeafLink['rel'];
  @Input() size: LeafLink['size'];
  @Input() target: LeafLink['target'];
  @Input() svg: LeafLink['svg'];

  /**
   * ********
   * CUSTOM ANGULAR PROPERTIES
   */
  @Input() routerLink: boolean;
  @Input() navigationExtras: NavigationExtras;

  @Output() click = new EventEmitter<MouseEvent>();

  constructor(private router: Router) {}

  handleClick(event: MouseEvent) {
    if (this.routerLink) {
      event.preventDefault();
      event.stopPropagation();
      this.router.navigateByUrl(this.href, this.navigationExtras);
    } else {
      this.click.emit(event);
    }
  }
}
